export default {
    getModelTipoFianza: (state) => {
        return state.tipoFianza
    },
    getTipoFianzaTpl: (state) => {
        if(state.operacion==="list"){
            return "tipo_fianzaList"
        }
    }
}